import { useContext } from 'react';

import { EventFormContext } from './event-form-context';

export const useDragExternalCalendarEvent = () => {
  const { onDragEvent } = useContext(EventFormContext);

  return onDragEvent;
};
